module.exports = __webpack_public_path__ + "static/img/rank_318.c8fa77a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_318.png
// module id = cSfp
// module chunks = 0